<template>
  <div class="wrapper">
    <div class="paper df-l-fs" v-if="info.fin">
      
      <!-- 头部 -->
      <section class="w100p">
        <div class="boldbig tac">{{info['companyName'+_lang]}}</div>
        <div class="tac m16">（{{info['shopName'+_lang]}}）</div>
      </section>
      <!-- 信息 -->
      <section class="w100p pb8">
        <div class="df row" v-for="(x1,i1) in info.bases" :key="i1">
          <span class="fsk0">{{$t('report.'+x1.key)}}：</span>
          <span class="f1" v-html="x1.value||x1['value'+_lang]"></span>
        </div>
      </section>
      <!-- 表格 -->
      <section class="w100p">
        <table class="w100p" v-for="(x1,i1) in tables" :key="i1" v-if="info[x1].length">
          <thead>
            <tr>
              <th colspan="7" class="bt pt8 tal">{{$t('report.'+x1)}}</th>
              <th colspan="1" class="bt pt8 tac">{{$t('report.count')}}</th>
              <th colspan="2" class="bt pt8 tar">{{$t('report.amount')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(x2,i2) in info[x1]" :key="'a'+i2">
              <td colspan="7" :class="{'pb8':i2===info[x1].length-1}">{{x2['itemName'+_lang]}}</td>
              <td colspan="1" :class="{'pb8':i2===info[x1].length-1}" class="tac">{{x2.count}}</td>
              <!-- <td cols2an="1" :class="{'pb8':i2===info[x1].length-1}" class="tar">{{x2.type===1?'+':'-'}}{{x2.amount|todoublezero}}</td> -->
              <td colspan="2" :class="{'pb8':i2===info[x1].length-1}" class="tar">{{x2.amount|todoublezero}}</td>
            </tr>
          </tbody>
        </table>
      </section>

    </div>
  </div>
</template>

<script>
let that
export default {
  name: 'Report3',
  filters: {
    todoublezero: val => {
      if (Number(val||0) >= 0) {
        if (that.sysEnv_x === 'us') {
          val = Number(val||0).toFixed(2)
        } else if (that.sysEnv_x === 'hk') {
          val = Number(val||0).toFixed(1)
        }
      } else {
        if (that.sysEnv_x === 'us') {
          // val = '-' + Number(-val||0).toFixed(2)
          val = '(' + Number(-val||0).toFixed(2) + ')'
        } else if (that.sysEnv_x === 'hk') {
          // val = '-' + Number(-val||0).toFixed(1)
          val = '(' + Number(-val||0).toFixed(1) + ')'
        }
      }
      return String(val).replace(/(\d)(?=(\d{3})+\.)/g, ($0,$1) => $1 + ',').replace(/\.$/, '')
    }
  },
  data() {
    return {
      info: {
        fin: false,
        companyName_zh: '',
        companyName_en: '',
        shopName_zh: '',
        shopName_en: '',
        bases: [
          {key:'address',value_zh:'',value_en:''},
          {key:'phone',value:''},
          {key:'date',value:''},
        ],
        combo: [],
        dish: [],
        comboDel: [],
        dishDel: [],
      },
      tables: ['combo', 'dish', 'comboDel', 'dishDel'],
    }
  },
  methods: {
    getReport() {
      this.$api.dish_report_search({ id: this.currentShopId }).then(res => {
        if (res.status === 0) {
          let _R = res.data
          // console.log(`%c报告:`, 'color: #f00;', _R)

          const {
            companyName,
            shopName_zh,
            shopName_en,
            addressList_zh,
            addressList_en,
            phone,
            date,
            itemReportList,
          } = _R

          this.info.companyName_zh = companyName
          this.info.companyName_en = companyName
          this.info.shopName_zh = shopName_zh
          this.info.shopName_en = shopName_en

          if (this.sysEnv_x==='us') {
            const arr_zh = JSON.parse(JSON.stringify(addressList_zh))
            this.info.bases[0].value_zh = arr_zh[0] + '<br/>'
            arr_zh.splice(0, 1)
            this.info.bases[0].value_zh += arr_zh.join(' ')
            const arr_en = JSON.parse(JSON.stringify(addressList_en))
            this.info.bases[0].value_en = arr_en[0] + '<br/>'
            arr_en.splice(0, 1)
            this.info.bases[0].value_en += arr_en.join(' ')
          } else if (this.sysEnv_x==='hk') {
            // this.info.bases[0].value_zh = addressList_zh.join(' ')
            // this.info.bases[0].value_en = addressList_en.join(' ')
            this.info.bases[0].value_zh = addressList_zh[3]
            this.info.bases[0].value_en = addressList_en[3]
          }

          this.info.bases[1].value = phone
          // this.info.bases[2].value = date.replace(/\-/g, '/')
          this.info.bases[2].value = date

          this.info.combo = itemReportList.filter(x1 => x1.setMenu && !x1.isDeleteItem)
          this.info.dish = itemReportList.filter(x1 => !x1.setMenu && !x1.isDeleteItem)
          this.info.comboDel = itemReportList.filter(x1 => x1.setMenu && x1.isDeleteItem)
          this.info.dishDel = itemReportList.filter(x1 => !x1.setMenu && x1.isDeleteItem)

          this.info.fin = true

        } else { this._status(res) }
      })
    },
  },
  created() {
    that = this
  },
}
</script>

<style lang="scss" scoped>
// *{margin: 0;padding: 0;box-sizing: border-box;font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Liberation Sans", "PingFang SC", "Microsoft YaHei", "Hiragino Sans GB", "Wenquanyi Micro Hei", "WenQuanYi Zen Hei", "ST Heiti", SimHei, SimSun, "WenQuanYi Zen Hei Sharp", sans-serif;}
*{margin: 0;padding: 0;box-sizing: border-box;}
// 1rem = 16px
.wrapper{
  height: 100%;overflow: scroll;flex-shrink: 0;
  .paper{
    width: 30rem;padding: 1rem;background: #fff;overflow: scroll;margin-bottom: 2rem;
    
    table{table-layout: fixed;}
    tr, .row{min-height: 24px;line-height: 24px;}
  
    .bt{border-top: 1px dashed #000;}
    .bb{border-bottom: 1px dashed #000;}
  
    .m16{margin: 1rem 0;}
    .mt8{margin-top: 0.5rem;}
    .pt8{padding-top: 0.5rem;}
    .pt16{padding-top: 1rem;}
    .mb8{margin-bottom: 0.5rem;}
    .pb8{padding-bottom: 0.5rem;}
  
    .tac{text-align: center;}
    .tal{text-align: left;}
    .tar{text-align: right;}
    .bold{font-weight: bold;}
    .boldbig{font-size: 1.5rem;font-weight: bold;}
    .line{height: 0;position: relative;top: 0;bottom: 0;margin: auto 1rem;}
  }
}
</style>